import React from 'react';
import PropTypes from 'prop-types';

const OfferIcon = ({ color, children, ...htmlProps }) => (
  <svg
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...htmlProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.806 5.36638c.2587.375.2587.87931 0 1.26724l-.4396.68535c-.0517.06465-.0647.15517-.0647.23275l.0259.80173c.0258.45259-.2198.89224-.6336 1.09914l-.72417.36207c-.07759.03879-.12931.09051-.16811.1681l-.36206.72414c-.2069.4138-.63362.6595-1.09914.6336l-.81466-.0517c-.07758 0-.1681.0259-.23276.0646l-.67241.4526c-.19397.1293-.41379.194-.63362.194-.21983 0-.43966-.0647-.63362-.194l-.67242-.4396c-.06465-.0517-.15517-.0647-.23275-.0647l-.81466.0517c-.45259.0259-.89224-.2198-1.09914-.6336l-.36207-.72411c-.03879-.06465-.09051-.12931-.1681-.1681l-.72414-.36207C.866379 9.25862.62069 8.8319.646552 8.36638l.051724-.81466c0-.09051-.012931-.1681-.051724-.25862l-.452586-.67241c-.2586212-.375-.2586212-.87931 0-1.26724l.439655-.67242c.051724-.06465.064655-.15517.064655-.23275l-.051724-.81466c-.025862-.45259.219827-.89224.633618-1.09914l.72414-.36207c.07759-.03879.12931-.09051.1681-.1681l.36207-.72414c.2069-.413791.63362-.65948 1.09914-.633618l.81466.051724c.09051 0 .1681-.012931.25862-.051724l.67241-.452586c.38793-.2586212.87931-.2586212 1.26724 0l.67242.439655c.06465.051724.15517.064655.23275.064655l.81466-.051724c.45259-.025862.89224.219827 1.09914.633618l.36207.72414c.03879.07759.09051.12931.1681.1681l.72411.36207c.4138.2069.6595.63362.6336 1.09914l-.0517.81466c0 .09051.013.1681.0517.24569l.4526.67241zm-7.11224.40079c.68535 0 1.25431-.56897 1.25431-1.25431 0-.68535-.56896-1.25432-1.25431-1.25432-.68534 0-1.25431.56897-1.25431 1.25432 0 .7112.55604 1.25431 1.25431 1.25431zm-.00078-1.82308c.32328 0 .5819.25862.5819.5819 0 .32327-.25862.56896-.5819.56896-.32328 0-.5819-.25862-.5819-.58189 0-.32328.25862-.56897.5819-.56897zm2.61309 2.28882c-.68535 0-1.25431.56897-1.25431 1.25431 0 .68535.56896 1.25431 1.25431 1.25431.68534 0 1.25431-.56896 1.25431-1.25431 0-.71121-.55604-1.25431-1.25431-1.25431zm.00019 1.82325c-.32327 0-.58189-.25862-.58189-.5819 0-.32327.25862-.5819.58189-.5819.32328 0 .5819.25863.5819.5819 0 .32328-.25862.5819-.5819.5819zm1.09905-4.46132c-.14224-.14224-.34914-.14224-.47845 0l-4.3319 4.31897c-.14224.14224-.14224.34913 0 .47844.06466.06466.15517.10345.23276.10345.07759 0 .1681-.03879.23276-.10345l4.31897-4.31896c.14224-.12931.14224-.33621.02586-.47845z"
      fill={color}
    />
    {children}
  </svg>
);

OfferIcon.defaultProps = {
  color: '#fff',
  width: 14,
  height: 14,
  children: null
};

OfferIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  children: PropTypes.node
};

export default OfferIcon;
